<template>
    <div>
        <div v-if="isSpinnerShow" class="d-flex justify-content-center mt-3 mb-3">
            <b-spinner label="Loading..."></b-spinner>
        </div>
        <div class="panel-tag mt-3" v-if="!isSpinnerShow && totalEntries == 0">{{$t('table.no_records')}}</div>
        <div v-if="!isSpinnerShow && totalEntries != 0" class="dataTables_wrapper dt-bootstrap4">
            <div class="row" data-spy="scroll" data-target="#itemSP" data-offset="0">
                <div class="col-sm-12 overflow-auto">
                    <b-table small striped hover bordered :fields="fields" :items="outstandingsItems" responsive>
                        <template #cell(index)="data">
                            {{ data.index + 1 }}
                        </template>
                        <template #cell(memberDisplayName)="data">
                            {{data.item.memberDisplayName == '' ? '-' : data.item.memberDisplayName}}
                        </template>
                        <template #cell(total)="data">
                            {{formatPrice(data.item.total)}}
                        </template>
                    </b-table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment'
import {handleSessionExpired} from './../../../../assets/js/dashboard/dashboard'
import {formatPrice} from './../../../../assets/js/dashboard/utilities'
export default {
    name: "outstandingsSummaryCustomer",
    data(){
        return{
            isSpinnerShow: false,
            outstandingsItems: [], totalEntries: 0, total: 0,
            filterObj: {}
        }
    }, 
    computed:{
        fields(){
            return[
                {key: "index", label: "#", thClass: 'thead-themed align-middle'},
                {key: "memberDisplayName", label: this.$i18n.t('table.header.name'), thClass: 'thead-themed align-middle', sortable: true},
                {key: "mobile", label: this.$i18n.t('table.header.contact'), thClass: 'thead-themed align-middle'},
                {key: "total", label: this.$i18n.t('table.header.balance'), thClass: 'thead-themed align-middle', sortable: true},
            ]
        },
        exportField(){
            var ret = {}
            ret["#"] = "index"
            ret[(this.$i18n.t('table.header.name')).toUpperCase()] = "name"
            ret[(this.$i18n.t('table.header.contact')).toUpperCase()] = "mobile"
            ret[(this.$i18n.t('table.header.balance')).toUpperCase()] = "balance"
            return ret
        }
    },
    watch:{
        "$i18n.locale"(val){
            if(this.filterObj.summaryType == 'customer'){
                this.setExportData(this.outstandingsItems)
            }
        }
    },
    methods:{
        formatPrice(price){
            return formatPrice(price)
        },
        async setCreditSummaryCustomer(filterObj){
            this.filterObj = filterObj
            let $vm = this;
            var dateFilter = "?startCreateDate=0&endCreateDate=" + moment(filterObj.dateBalance.startDate).endOf('day').unix()
            var searchFilter = filterObj.search == "" ? "" : "&search=" + filterObj.search

            let QUERY_STRING = this.$api.REPORT_BALANCE + dateFilter + searchFilter 
            const url =  this.$api.REPORT_OUTSTANDINGS + QUERY_STRING;

            $vm.isSpinnerShow = true;
            await $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                $vm.outstandingsItems = response.data.result;
                $vm.totalEntries = response.data.count;
                $vm.getTotal();
                $vm.isSpinnerShow = false;
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            $vm.setExportData($vm.outstandingsItems)
        },
        getTotal(){
            this.total = 0;
            for(var i=0; i<this.outstandingsItems.length; i++){
                this.total += this.outstandingsItems[i].total;
            }
            this.$emit('setBalanceSummary', this.total)
        },
        setExportData(data){
            var strDate = moment(this.filterObj.dateBalance.startDate).format(this.$msg.CST.DATE_FORMAT)

            let header = this.$msg.REPORT.HEADER + this.$i18n.t(`subMenu.salon_report_outstandings`) + "(" + this.$i18n.messages[this.$i18n.locale].tab.reportCreditTabs[0].text + ")" + " " + strDate
            var exportHeaders = [
                this.$msg.REPORT.HEADER + this.$i18n.t(`subMenu.salon_report_outstandings`), 
                this.$i18n.t('table.header.date') + ": " + strDate , 
                this.$i18n.t('table.report_generate') + moment().format(this.$msg.CST.DATE_TIME_24), 
                this.$i18n.t('salon_report.view') + this.$i18n.messages[this.$i18n.locale].tab.summary_type[0].text,
                " "];
            var exportFileName =  header.split(" ").join("_") +  this.$msg.REPORT.CSV

            var exportData = []
            for(var i=0; i<data.length; i++){
                exportData.push({
                    index: i+1,
                    name: data[i].memberDisplayName == '' ? '-' : data[i].memberDisplayName,
                    mobile: data[i].mobile,
                    balance: data[i].total
                })
            }

            exportData.push({
                    index: "",
                    name: "",
                    mobile: this.$i18n.t('label.total'),
                    balance: this.total
                })

            var exportObj = {
                data: exportData,
                fields: this.exportField,
                headers: exportHeaders,
                fileName: exportFileName
            }
            this.$emit('setExportData', exportObj)
        }
    }
}
</script>
<style scoped>
.border-top-bottom-2{
    border-top-width:  2px !important;
    border-bottom-width:  2px !important;
}
</style>